// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import i18n from './i18n'
import filters from './filters'
import './plugins'
import { mixin as clickaway } from 'vue-clickaway'
import VueApexChart from 'vue-apexcharts'
import VueWorker from 'vue-worker'
import AsyncComputed from 'vue-async-computed'
import 'nprogress/nprogress.css'

Vue.use(AsyncComputed)
Vue.use(VueWorker)

Vue.component('VueApexChart', VueApexChart)

Vue.mixin(clickaway)

require('./assets/style/app.scss')
Vue.config.productionTip = false
Vue.config.devtools = true

Vue.use(require('vue-moment'))

const requireComponent = require.context(
	'./components',
	// look for subfolder
	true,
	/(App|Layout)[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
	// Get component config
	const componentConfig = requireComponent(fileName)
	const componentName = fileName
		.split('/')
		.pop()
		.replace(/\.\w+$/, '')

	// Register component globally
	Vue.component(
		componentName,
		// Look for the component options on `.default`, which will
		// exist if the component was exported with `export default`,
		// otherwise fall back to module's root.
		componentConfig.default || componentConfig
	)
})

/* eslint-disable no-new */
new Vue({
	el: '#app',
	store,
	i18n,
	router,
	components: { App, filters },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js